import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = {
  class: "sp_detail_all"
};
const _hoisted_3 = {
  class: "sp_detail_one acea-row row-top"
};
const _hoisted_4 = {
  class: "sp_item_pic"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "sp_item_kuang acea-row row-top"
};
const _hoisted_7 = {
  class: "sp_item_title acea-row row-top"
};
const _hoisted_8 = {
  class: "sp_item_miaoshu acea-row row-between-wrapper"
};
const _hoisted_9 = {
  class: "sp_item_cateidname"
};
const _hoisted_10 = {
  class: "sp_item_dinglist"
};
const _hoisted_11 = {
  class: "sp_item_dingitem acea-row row-between-wrapper"
};
const _hoisted_12 = {
  class: "sp_item_sampbianhao"
};
const _hoisted_13 = {
  class: "sp_item_lianxiren_name"
};
const _hoisted_14 = {
  class: "sp_detail_two acea-row row-top"
};
const _hoisted_15 = {
  class: "sp_detail_two_left"
};
const _hoisted_16 = {
  class: "sp_detail_two_left_one acea-row row-top"
};
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = ["innerHTML"];
const _hoisted_20 = {
  class: "sp_detail_two_right"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "shop_pic acea-row row-center-wrapper"
};
const _hoisted_23 = ["src"];
const _hoisted_24 = {
  class: "shop_name acea-row row-center-wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_zrcheader = _resolveComponent("zrcheader");
  const _component_zrcfooter = _resolveComponent("zrcfooter");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_zrcheader, {
    xzmenu: $data.xzmenu
  }, null, 8, ["xzmenu"]), _cache[9] || (_cache[9] = _createElementVNode("div", {
    class: "shop_postion"
  }, "当前位置： 主页 > 项目详情", -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
    src: $data.projectinfo.image
  }, null, 8, _hoisted_5)]), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, _toDisplayString($data.projectinfo.title), 1), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString($data.projectinfo.cate_id_name) + " " + _toDisplayString($data.projectinfo.cateson_id_name), 1), _createElementVNode("div", {
    class: "sp_item_seemore",
    onClick: _cache[0] || (_cache[0] = $event => $options.goprojectdingdan($data.projectinfo.id, 2))
  }, "立即下单")]), _cache[4] || (_cache[4] = _createElementVNode("div", {
    class: "sp_item_miaoshu acea-row row-top"
  }, null, -1)), _cache[5] || (_cache[5] = _createElementVNode("div", {
    class: "sp_item_btn acea-row row-right"
  }, null, -1)), _cache[6] || (_cache[6] = _createElementVNode("div", {
    class: "sp_item_dingdan"
  }, "最新订单信息", -1)), _createElementVNode("div", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.project_dingdan_list, item => {
    return _openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.sampbianhao), 1), _createElementVNode("div", _hoisted_13, _toDisplayString(item.shiyan_lianxiren_name), 1), _createElementVNode("div", null, _toDisplayString(item.shiyan_lianxiren_tel), 1)]);
  }), 256))])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
    class: _normalizeClass(["sp_detail_spjstitle", [$data.xztitlenum == 1 ? 'spjstitle_xzitem' : 'spjstitle_noitem']]),
    onClick: _cache[1] || (_cache[1] = $event => $data.xztitlenum = 1)
  }, "样品要求", 2), _createElementVNode("div", {
    class: _normalizeClass(["sp_detail_spjstitle", [$data.xztitlenum == 2 ? 'spjstitle_xzitem' : 'spjstitle_noitem']]),
    onClick: _cache[2] || (_cache[2] = $event => $data.xztitlenum = 2)
  }, "项目介绍", 2), _createElementVNode("div", {
    class: _normalizeClass(["sp_detail_spjstitle", [$data.xztitlenum == 3 ? 'spjstitle_xzitem' : 'spjstitle_noitem']]),
    onClick: _cache[3] || (_cache[3] = $event => $data.xztitlenum = 3)
  }, "常见问题", 2)]), $data.xztitlenum == 1 ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "sp_detail_two_left_two",
    innerHTML: $data.projectinfo.sample
  }, null, 8, _hoisted_17)) : _createCommentVNode("", true), $data.xztitlenum == 2 ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "sp_detail_two_left_two",
    innerHTML: $data.projectinfo.introduce
  }, null, 8, _hoisted_18)) : _createCommentVNode("", true), $data.xztitlenum == 3 ? (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "sp_detail_two_left_two",
    innerHTML: $data.projectinfo.question
  }, null, 8, _hoisted_19)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_20, [_cache[8] || (_cache[8] = _createElementVNode("div", {
    class: "shop_title"
  }, "热门商品", -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.projectlist, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "shop_list martopershi",
      onClick: $event => $options.goprojectdetail(item.id, 2)
    }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("img", {
      src: item.image
    }, null, 8, _hoisted_23)]), _createElementVNode("div", _hoisted_24, _toDisplayString(item.title), 1), _cache[7] || (_cache[7] = _createElementVNode("div", {
      class: "shop_btn acea-row row-center-wrapper"
    }, [_createElementVNode("div", {
      class: "shop_chakan acea-row row-center-wrapper"
    }, " 立即查看 ")], -1))], 8, _hoisted_21);
  }), 256))])])]), _createVNode(_component_zrcfooter)]);
}